var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8613 25.675H6.98433V13.156H10.8613V25.675ZM8.90433 11.517C7.63733 11.517 6.61133 10.483 6.61133 9.20697C6.61133 7.93097 7.63733 6.89697 8.90433 6.89697C10.1713 6.89697 11.1963 7.93097 11.1963 9.20697C11.1963 10.483 10.1703 11.517 8.90433 11.517ZM25.3893 25.675H21.5313V19.104C21.5313 17.302 20.8463 16.295 19.4203 16.295C17.8693 16.295 17.0583 17.343 17.0583 19.104V25.675H13.3403V13.156H17.0583V14.842C17.0583 14.842 18.1763 12.773 20.8333 12.773C23.4903 12.773 25.3893 14.394 25.3893 17.748V25.675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4be4687b09f171f67399fab6d7b6c8b0.svg";
export { ForwardRef as ReactComponent };